import videojs from 'video.js';

const Component = videojs.getComponent('Component');
const ClickableComponent = videojs.getComponent('ClickableComponent');

const defaultOptions = { };

export default class ButtonToggleStreamShopping extends ClickableComponent {
  constructor(player, options) {
    super(player, options);
    this.player = player;
    this.options = videojs.mergeOptions(defaultOptions, options);
    if (!this.player.el().classList.contains('vjs-stream-shopping_visible')) {
      // Слайдер с товарами изначально должен быть открыть
      this.handleClick();
    }
  }

  createEl() {
    const button = videojs.createEl('button', {
      className: 'vjs-stream-shopping-toggle vjs-control vjs-button',
    });
    const content = videojs.createEl('span', {
      className: 'vjs-icon-placeholder',
    });
    button.appendChild(content);
    return button;
  }

  handleClick() {
    const isVisible = this.player.el().classList.toggle('vjs-stream-shopping_visible');
    this.trigger(isVisible ? 'StreamShopping/visible' : 'StreamShopping/hidden');
  }
}

Component.registerComponent('ButtonToggleStreamShopping', ButtonToggleStreamShopping);
